import habilidadadesApi from "../../api/Alumno/habilidadadesApi";
import { message } from 'antd';


export default { 
    getHabilidadesMe: async () => {
        const response = await habilidadadesApi.getHabilidadesMe();
        if (!response.success) {
            message.error(response.message);
            response.data = [];
        }
        return response;
    },
    createHabilidad: async (data) => {
        const response = await habilidadadesApi.createHabilidad(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    editHabilidad: async (data) => {
        const response = await habilidadadesApi.editHabilidad(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    deleteHabilidad: async (id) => {
        const response = await habilidadadesApi.deleteHabilidad(id);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
}